// extracted by mini-css-extract-plugin
export var boldText = "events-module--bold-text--f7cb0";
export var box = "events-module--box--d8fb8";
export var contentWrapper = "events-module--contentWrapper--db5c0";
export var eventImage = "events-module--event-image--d2f9d";
export var linkHover = "events-module--link-hover--ee333";
export var redText = "events-module--red-text--34fa6";
export var smallText = "events-module--small-text--4657e";
export var tabletOnly = "events-module--tablet-only--ffdd8";
export var textDiv = "events-module--text-div--1791c";